import type { StoreConfig } from '../lib/stores';

interface StoreGroupHeaderProps {
  store: StoreConfig;
  itemCount: number;
}

export default function StoreGroupHeader({ store, itemCount }: StoreGroupHeaderProps) {
  return (
    <div className="store-group-header">
      <a
        href={store.storefrontUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="store-group-link"
        title={`Visit ${store.name}`}
      >
        <img
          src={store.logoUrl}
          alt={store.name}
          className="store-group-logo"
          crossOrigin="anonymous"
          onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
        />
        <span className="store-group-name">{store.name}</span>
      </a>
      <span className="store-group-count">
        {itemCount} item{itemCount !== 1 ? 's' : ''}
      </span>
    </div>
  );
}
